export const AUTHROUTES = {
	login: '/auth/employee_login',
	logout: '/auth/logout',
	change_password: '/employee/change_password',
	dynamicLink: '/system-settings/get-link',
}
export const USERROUTES = {
	name: 'user',
	device: 'user/devices',
	support_create_account: 'user/support-create-account',
}
export const USERACTIVITYROUTES = {
	name: '/user-activity',
	overview: '/user-activity/overview',
	export: '/user-activity/export',
	notes: (userId: string) => `/user-activity/${userId}/notes`,
	sendEmail: (userId: string) => `/user-activity/${userId}/send-email`,
}
export const CMSNOTEROUTES = {
	name: '/cms-note',
	item: (id: string) => `/cms-note/${id}`,
}
export const EMPLOYEEROUTES = {
	name: 'employee',
	change_password: '/employee/change_password',
}
export const ROLEROUTES = {
	name: 'role',
}
export const SETTINGROUTES = {
	name: 'system-settings',
	exchangeRate: 'system-setting/exchange-rate',
}
export const BANNERROUTES = {
	name: 'banner',
}
export const CATEGORYTRAILS = {
	name: 'category',
	trail: 'trail',
	addTrails: 'category_trail',
	sort: 'category/sort',
}
export const CHARTROUTES = {
	name: '/statistic/users',
	information: '/statistic/information',
	provinceUser: 'statistic/get-chart-province-user',
	countryUser: 'statistic/get-chart-country-user',
	usersByCountry: 'statistic/get-users-by-country',
	usersByProvince: 'statistic/get-users-by-province',
	versionStats: 'statistic/version-stats',
	onlineUsersCount: '/statistic/online-users-count',
	newUserMetrics:'statistic/new-user-metrics', // bang 1
	retentionMetrics:'statistic/retention-metrics', // bang 2
	activeUserMetrics:'statistic/active-user-metrics', // bang 3
	sectionAnalytics:'statistic/section-analytics', // bang 4
	sectionFeatureUsage:'statistic/feature-usage', // bang 5
	sectionEngagement:'statistic/engagement', // bang 6
	communityStats: 'statistic/community-stats',
	
}
export const CONFIGPHONEROUTES = {
	name: 'phone-special',
}
export const OTPROUTES = {
	optTracking: 'otp-tracking',
	balance: 'otp-tracking/balance',
	balances: 'otp-tracking/balances',
}
export const NOTIROUTES = {
	name: 'push_notification',
	pushNoti: 'push_notification/send_fcm_to_group',
}
export const SUPPORTINBOXROUTES = {
	name: 'support-inbox',
	sourceUser: 'support-inbox/source-user',
	searchSourceUser: 'support-inbox/source-user/search',
	campaigns: 'support-inbox/campaigns',
	sendCampaign: (id: string) => `support-inbox/campaigns/${id}/send`,
	events: (id: string) => `support-inbox/campaigns/${id}/events`,
	recipients: (id: string) => `support-inbox/campaigns/${id}/recipients`,
}
export const SERVICEROUTES = {
	name: 'addition',
}
export const CONVERSIONROUTES = {
	name: 'conversation',
	cmsCommunities: 'conversation/cms/communities',
	cmsCommunityStatistics: 'conversation/cms/communities/statistics',
	cmsCommunityCategories: 'conversation/cms/communities/categories',
	cmsCommunityLocations: 'conversation/cms/communities/locations',
	cmsCommunityLocationStats: 'conversation/cms/communities/location-stats',
}
export const EVENTROUTES = {
	name: '/post',
	customEvents: '/post/admin/custom-events',
	customEventsStatistics: '/post/admin/custom-events/statistics',
}
export const EVENTCANDIDATEROUTES = {
	approvePost: (postId: string) => `/event-candidate/post/${postId}/approve`,
	rejectPost: (postId: string) => `/event-candidate/post/${postId}/reject`,
	run: '/event-candidate/run',
	runStatus: '/event-candidate/run/status',
}
export const BOOKROUTES = {
	book: '/book',
	chapterInProgressUser: '/chapter/get-in-progress-user',
	chapter: '/chapter',
	bookUniVini: '/book/admin/list',
	bookAudioList: '/book/audio/list',
	chapterDetails: (id: string) => `/chapter/${id}/details`,
	univiniChapters: (bookId: string) => `/chapter/univini-book/${bookId}`,
	chapterStatus: (id: string) => `/chapter/${id}/status`,
	editPublishedChapter: (id: string) => `/chapter/${id}/edit-published`,
	updatePublishedChapter: (id: string) => `/chapter/${id}/update-published`,
	downloadChapterText: (id: string, language: string) =>
		`/chapter/${id}/download-text/${language}`,
	unpublishChapter: (id: string) => `/chapter/${id}/unpublish`,
	publishChapters: '/chapter/publish/list',
	createPublishedChapter: '/chapter/create-published',
}
export const STICKERROUTES = {
	name: 'sticker',
	itemsFromZip: (id: string) => `sticker/${id}/items-from-zip`,
	item: (stickerId: string, itemId: string) =>
		`sticker/${stickerId}/items/${itemId}`,
}
export const CONFIGCACHEROUTES = {
	name: 'config-cache',
	increment: (key: string) => `config-cache/${key}/increment`,
	item: (key: string) => `config-cache/${key}`,
}
export const GOOGLEAPIROUTES = {
	geocodeStats: 'map/google/geocode/stats',
	placesTextSearchStats: 'map/google/place/textsearch/stats',
	placesAutocompleteStats: 'map/google/place/autocomplete/stats',
}

export const BLOCKROUTES = {
	name: 'block',
}

export const REPORTROUTES = {
	name: 'reports',
	stats: 'reports/stats',
	status: (id: string) => `reports/${id}/status`,
	note: (id: string) => `reports/${id}/note`,
	replyEmail: (id: string) => `reports/${id}/reply-email`,
	blockTarget: (id: string) => `reports/${id}/block-target`,
	deleteContent: (id: string) => `reports/${id}/delete-content`,
	reject: (id: string) => `reports/${id}/reject`,
}

export const REDEEMREQUESTROUTES = {
	list: '/redeem-request/cms',
	stats: '/redeem-request/cms/stats',
	markPaid: (id: string) => `/redeem-request/cms/${id}/mark-paid`,
	reject: (id: string) => `/redeem-request/cms/${id}/reject`,
}

export const BADWORDROUTES = {
	categories: 'bad-word-categories',
	words: 'bad-words',
	moderationCases: 'content-moderation/cases',
	approveCase: (id: string) => `content-moderation/cases/${id}/approve`,
	hideCase: (id: string) => `content-moderation/cases/${id}/hide`,
}

export const CHANGELOGROUTES = {
	name: '/changelog',
	publish: (id: string) => `/changelog/${id}/publish`,
	unpublish: (id: string) => `/changelog/${id}/unpublish`,
}

export const TUTORAPPROUTES = {
	tutorForLearner: '/learner/tutor-for-learner',
	learnerForTutor: '/tutor/leaner-for-tutor',
	learnerMyPosts: '/learner/my-posts',
	myCourses: '/course/my-courses',
	myCoursesUniVini: '/course/my-courses-univini',
	cmsStatistics: '/find-my-tutor/cms/statistics',
	cmsCountries: '/find-my-tutor/cms/countries',
	cmsList: (type: 'tutor' | 'learner' | 'course' | 'post') =>
		`/find-my-tutor/cms/${type}s`,
	cmsItem: (type: 'tutor' | 'learner' | 'course' | 'post', id: string) =>
		`/find-my-tutor/cms/${type}/${id}`,
	cmsHide: (type: 'tutor' | 'learner' | 'course' | 'post', id: string) =>
		`/find-my-tutor/cms/${type}/${id}/hide`,
}

export const FINDMYGUIDEROUTES = {
	cmsStatistics: '/fmg-service/cms/statistics',
	cmsListings: '/fmg-service/cms/listings',
	cmsCategories: '/fmg-service/cms/categories',
	cmsListingItem: (id: string) => `/fmg-service/cms/listings/${id}`,
	cmsListingHide: (id: string) => `/fmg-service/cms/listings/${id}/hide`,
	cmsDeletedProfiles: '/fmg-service/cms/deleted-profiles',
	cmsRestoreDeletedProfile: (id: string) =>
		`/fmg-service/cms/deleted-profiles/${id}/restore`,
}

export const YOURLISTROUTES = {
	lmbListing: {
		name: 'lmb-listing',
		cms: {
			name: 'cms',
			listings: '/lmb-listing/cms/listings',
			statistics: '/lmb-listing/cms/statistics',
			item: (id: string) => `/lmb-listing/cms/listings/${id}`,
			archive: (id: string) => `/lmb-listing/cms/listings/${id}/archive`,		
		} 
	}
}

export const COURSEAIROUTES = {
	list: '/course-ai',
	detail: (id: string) => `/course-ai/${id}`,
	topicStat: '/course-ai/cms/topic-stat',
	writingTopics: '/course-ai/cms/writing-topic-prototypes',
	writingTopic: (id: string) => `/course-ai/cms/writing-topic-prototypes/${id}`,
	dictationTopics: '/course-ai/cms/dictation-topics',
	dictationTopicPrototypes: '/course-ai/cms/dictation-topic-prototypes',
	dictationTopic: (id: string) => `/course-ai/cms/dictation-topic-prototypes/${id}`,
	learners: '/course-ai/admin/learners',
	learnersSummary: '/course-ai/admin/learners/summary',
	learnersRevenueByMonth: '/course-ai/admin/learners/revenue-by-month',
	learnersRevenueByDay: '/course-ai/admin/learners/revenue-by-day',
	learnersExport: '/course-ai/admin/learners/export',
	learnersFilters: '/course-ai/admin/learners/filters',
	learnerRefunds: '/course-ai/admin/learners/refunds',
	learnerRefundRefunded: (id: string) => `/course-ai/admin/learners/refunds/${id}/refunded`,
	learnerRefundReject: (id: string) => `/course-ai/admin/learners/refunds/${id}/reject`,
	learnerRefundLockout: (id: string) => `/course-ai/admin/learners/refunds/${id}/lockout`,
	learnerSupportConversation: (userId: string) => `/course-ai/admin/learners/${userId}/support-conversation`,
	learnerSupportMessages: (userId: string) =>
		`/course-ai/admin/learners/${userId}/support-conversation/messages`,
	// UD-627: the two staff codes and Kick. A code is never part of a path: the code to change is named by its kind.
	staffJoinCodes: '/course-ai/admin/staff-join-codes',
	staffJoinCodeRegenerate: (codeType: 'tutor' | 'purchased') =>
		`/course-ai/admin/staff-join-codes/${codeType}/regenerate`,
	learnerKick: (userCourseId: string) => `/course-ai/admin/user-courses/${userCourseId}/kick`,
}
